"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListSelectPopover = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 *  The ListSelectPopover presents a modal dialog for selecting an item from an Autocomplete list. The caller must pass in props:
 *  
 *  a boolean called "isOpen" which determines whether the dialog is open or not
 *  an array called items with a list of all the possible items to select from
 *      if items are Strings, they are used directly as values
 *      if items are Objects, and have a .name property, the name is displayed
 *  
 *  a string called "title" which is the title of the dialog
 *  a function called "okCallback" which takes a the value selected, called when the Ok button is pressed with the selected value as the argument
 *  a function called "cancelCallback" which is called when the Cancel button is pressed
 *  a function called "noneCallback", if the none button is pressed to select nothing in the list. If this callback is null, there is no "None" button.
 *  
 *  After one of the callback buttons is pressed, the selected item is cleared to allow reuse of the component
 * 
 */
var ListSelectPopover = exports.ListSelectPopover = /*#__PURE__*/function (_Component) {
  function ListSelectPopover(props) {
    var _this;
    _classCallCheck(this, ListSelectPopover);
    _this = _callSuper(this, ListSelectPopover, [props]);
    _defineProperty(_this, "styles", {
      button: {
        marginTop: 10,
        marginLeft: 10,
        marginRight: 10
      },
      container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    });
    _defineProperty(_this, "_title", void 0);
    _defineProperty(_this, "_okCallback", void 0);
    _defineProperty(_this, "_cancelCallback", void 0);
    _defineProperty(_this, "_noneCallback", void 0);
    _defineProperty(_this, "state", {
      selectedItem: '',
      selectedItemValue: ''
    });
    _defineProperty(_this, "_okButtonPressed", function () {
      _this._okCallback(_this.state.selectedItem);
      _this.setState({
        selectedItem: '',
        selectedItemValue: ''
      }); //clear for next time
    });
    _defineProperty(_this, "_cancelButtonPressed", function () {
      _this._cancelCallback();
      _this.setState({
        selectedItem: '',
        selectedItemValue: ''
      }); //clear for next time
    });
    _defineProperty(_this, "_noneButtonPressed", function () {
      _this._noneCallback();
      _this.setState({
        selectedItem: '',
        selectedItemValue: ''
      }); //clear for next time        
    });
    _this._title = props.title;
    _this._okCallback = props.okCallback;
    _this._cancelCallback = props.cancelCallback;
    _this._noneCallback = props.noneCallback;
    return _this;
  }
  _inherits(ListSelectPopover, _Component);
  return _createClass(ListSelectPopover, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var maxWidth = window.innerWidth * 0.66; //two thirds the window, up to 650
      if (maxWidth > 650) maxWidth = 650;
      var open = false;
      if (this.props.isOpen === true) open = true;
      return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
        open: open,
        anchorReference: "anchorPosition",
        anchorPosition: {
          left: window.innerWidth / 2,
          top: window.innerHeight / 2
        },
        transformOrigin: {
          vertical: 'center',
          horizontal: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
        style: {
          margin: 20,
          width: maxWidth
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
        variant: "subtitle1",
        style: {
          fontWeight: 'bold',
          marginBottom: 20
        }
      }, this._title), /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
        size: "small",
        value: this.state.selectedItem,
        onChange: function onChange(event, newValue) {
          _this2.setState({
            selectedItem: newValue
          });
        },
        inputValue: this.state.selectedItemValue,
        onInputChange: function onInputChange(event, newValue) {
          _this2.setState({
            selectedItemValue: newValue
          });
        },
        options: this.props.items,
        blurOnSelect: true,
        getOptionLabel: function getOptionLabel(option) {
          return option.name ? option.name : option;
        },
        disableClearable: true,
        renderInput: function renderInput(params) {
          return /*#__PURE__*/_react["default"].createElement(_core.TextField, _extends({}, params, {
            variant: "outlined",
            InputLabelProps: {
              shrink: true
            }
          }));
        }
      }), /*#__PURE__*/_react["default"].createElement(_core.Container, {
        style: this.styles.container
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        disabled: !this.state.selectedItem,
        onClick: this._okButtonPressed,
        color: "primary",
        variant: "outlined",
        style: this.styles.button
      }, "OK"), this._noneCallback ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
        onClick: this._noneButtonPressed,
        variant: "outlined",
        style: this.styles.button
      }, "None") : null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        onClick: this._cancelButtonPressed,
        variant: "outlined",
        style: this.styles.button
      }, "Cancel"))));
    }
  }]);
}(_react.Component);